
















import { Component, Prop, Vue } from "vue-property-decorator";
import { Editor } from "./editor";

@Component
export default class ExpressionEditor extends Vue {
  @Prop() expressionInternal!: string;
  @Prop() expressionTex!: string;
  @Prop() readonly?: boolean;
  @Prop() wrap?: boolean;
  @Prop() hideHint?: boolean;

  private _editor: Editor | null = null;

  mounted() {
    const answerDiv = this.$refs.expression as HTMLElement;
    const errorDiv = this.$refs.errorDiv as Element;

    const self = this;
    setTimeout(() => {
      self._editor = new Editor(answerDiv, errorDiv, "", !!self.wrap);
      if (self.readonly) {
        self._editor.readonly = self.readonly;
      }

      self._editor.onNotify = cb => {
        self.$emit("update", cb);
      };

      self._editor.onUpdate = cb => {
        let obj: string[] = [];
        for (let o of cb) {
          if (o === "selection" || o === "cursor") {
            obj.push(o);
          }
        }
        if (obj.length > 0) {
          self.$emit("update", obj);
        }
      };

      if (self.expressionInternal) {
        self._editor.setInternal(this.expressionInternal);
      } else if (this.expressionTex) {
        self._editor.setTex(this.expressionTex);
      }
    }, 0);
  }

  keyDown(e: KeyboardEvent) {
    this.$emit("key", e);
  }

  validate(): boolean {
    if (this._editor) {
      return this._editor.validation();
    }
    return false;
  }

  getGRL(): string | undefined {
    if (this._editor) {
      this._editor.validation();
      return this._editor.getGRL();
    }
  }

  setGRL(grl: string): void {
    if (this._editor) {
      this._editor.setGRL(grl);
    }
  }

  setInternal(math: string): void {
    if (this._editor) {
      this._editor.setInternal(math);
    }
  }

  getChararcterSpeech(): string {
    if (this._editor) {
      return this._editor.getChararcterSpeech();
    } else {
      return "";
    }
  }

  getSemanticSpeech(): string {
    if (this._editor) {
      return this._editor.getSemanticSpeech();
    } else {
      return "";
    }
  }
  showMobileKeyboard(): void {
    if (this._editor) {
      this._editor.showMobileKeyboard();
    }
  }
  insertTrig(name: string): void {
    if (this._editor) {
      this._editor.insertTrig(name);
    }
  }

  get editor(): Editor {
    if (!this._editor) {
      throw new Error(
              "No editor for dsome reason, probably the component is accessed before mounting"
      );
    }
    return this._editor;
  }

  touchStart(event: TouchEvent) {
    event.preventDefault();
    if (!this.readonly) {
      this.showMobileKeyboard();
    }
  }
}
